import Scroll from './common/_scroll';
import Modal from './common/_modal';

const scroll = new Scroll();
const modal = new Modal();